import _toConsumableArray from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-precision.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import { mixin } from "@/mixins/register.js";
import { localStorage, setTimeLocalStorage } from "@/store/storage";
import moment from "moment";
import Signin from "@/api/modules/signin";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { AUTION } from "@/config/parameters.js";
import Empty from "@/components/common/empty";
import { floatingNumber } from "@/utils/utils";
import floatOPS from "@/utils/floatOPS";
import numberSkeleton from "@/components/numberSkeleton/index";
import registerLoad from "@/components/registerLoad/index.vue";
import gasNumber from "@/components/gasNumber/index";
import CurrencySelect from "@/components/currencySelect/index.vue";
export default {
  name: "shoppingCart",
  props: {
    drawerShow: {
      modelValue: Boolean
    },
    registerPop: {
      modelValue: Boolean
    }
  },
  components: {
    Empty: Empty,
    numberSkeleton: numberSkeleton,
    registerLoad: registerLoad,
    gasNumber: gasNumber,
    CurrencySelect: CurrencySelect
  },
  mixins: [mixin],
  data: function data() {
    return {
      activeNames: ["99"],
      showPopover: false,
      couponList: [],
      shopCartList: [],
      loading: true,
      originalPrice: 0,
      price: 0,
      shopList: [],
      nowActive: 1,
      images: require("@/assets/image/shoppingCart/pic_empty_favorites.png"),
      shopCartListInit: [],
      copuonCollapse: "99",
      inputFlag: null,
      searchStatus: false,
      registerPayMethod: ""
    };
  },
  watch: {
    chainid: {
      handler: function handler(to, from) {
        if (to || from) {
          if (this.account) {
            this.init();
          }
        }
      },
      deep: true,
      immediate: false
    },
    account: {
      handler: function handler(to, from) {
        if (to && this.chainid) {
          this.loading = true;
          this.init();
        }
        if (!to) {
          this.reset();
        }
      },
      deep: true,
      immediate: false
    },
    registerPop: {
      handler: function handler(to, from) {
        if (to) {
          if (this.account) {
            this.init();
          }
        } else {
          if (this.gasTime) {
            clearInterval(this.gasTime);
            this.gasTime = null;
          }
          if (!localStorage.getObject("shoppingCartList")) {
            this.reset();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: _objectSpread(_objectSpread({
    name: function name(_name) {
      return function (name) {
        if (name && name.length > 25 && !this.isMobile) {
          return name.substr(0, 12) + "..." + name.substr(name.length - 12, 12);
        }
        return name;
      };
    },
    getOriginalPrice: function getOriginalPrice(priceDiscount, originalPrice) {
      return function (priceDiscount, originalPrice) {
        var num = floatOPS.d(originalPrice, priceDiscount, 2);
        return num;
      };
    }
  }, mapState(["chainid", "account", "accessToken", "signConnectCallBack5"])), {}, {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    }
  }),
  mounted: function mounted() {
    this.$store.commit("setConnectPosition", 8);
    if (!this.account) {
      this.loading = false;
    }
  },
  beforeCreate: function beforeCreate() {
    this.couponList = [];
    this.loading = true;
    var arr = localStorage.getObject("shoppingCartList");
    if (!this.$store.state.account) {
      this.shopCartList = [];
      this.shopList = [];
      this.loading = false;
      return;
    }
    if (!arr) {
      this.loading = false;
      return;
    }
    arr = arr.map(function (item) {
      item.showList = true;
      return item;
    });
    this.shopCartList = arr;
    this.shopList = arr;
  },
  methods: {
    reset: function reset() {
      this.couponList = [];
      this.loading = true;
      var arr = localStorage.getObject("shoppingCartList") || [];
      if (!this.$store.state.account) {
        this.shopCartList = [];
        this.shopList = [];
        this.loading = false;
        return;
      }
      if (!arr) {
        this.loading = false;
        return;
      }
      arr = arr.map(function (item) {
        item.showList = true;
        return item;
      });
      this.shopCartList = arr;
      this.shopList = arr;
    },
    registerNumber: function registerNumber(list, e) {
      var _this = this;
      var num = 0;
      list.forEach(function (item, i) {
        if (!_this.isUnSupport(item.registerChainIds).status) {
          if (e) {
            if (item.showList) {
              if (item.domainStatus == 0 && !item.protectFlag || item.domainStatus == 0 && item.protectFlag && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _this.$store.state.account.toLowerCase()) {
                num = num + 1;
              }
            }
          } else {
            if (item.showList) {
              if (item.domainStatus == 0 && !item.protectFlag || item.domainStatus == 0 && item.protectFlag && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _this.$store.state.account.toLowerCase()) {
                num = num + 1;
              }
            }
          }
        }
      });
      return num;
    },
    focusBox: function focusBox(e) {
      if (this.inputFlag) {
        if (e != 1) {
          this.$refs["select-card"].blur();
        } else {
          this.$refs["select-card1"].blur();
        }
      }
    },
    visibleChange: function visibleChange(val) {
      var _this2 = this;
      this.$setBodyStyle(val);
      setTimeout(function () {
        _this2.inputFlag = val;
      }, 100);
    },
    cleanVal: function cleanVal() {
      if (!this.invitationCode) {
        this.inviteeDiscount = 1;
        this.setPrice();
      }
    },
    usdPriceAdd: function usdPriceAdd() {
      if (this.currencyId == this.chainid || !this.currencyId) {
        this.gasPrice = this.gasPriceInit;
      }
      if (this.gasPrice) {
        var num = "".concat(Number(this.gasPrice) + Number(this.price));
        var arrNum = num.split(".");
        var num1 = Number(arrNum[0]);
        var num2 = Number("0." + arrNum[1]);
        if (num2 < 0.01) {
          num = Number(num1) + Number(num2.toPrecision(1));
        } else {
          num = (Number(num1) + Number(num2)).toFixed(2);
        }
        this.usdtPariceNum = num;
        if (this.currencyId == this.chainid || !this.currencyId) {
          this.getUseNum(num);
        } else {
          this.getUseNum(this.price);
        }
      }
    },
    handleType: function handleType(e) {
      if (this.sessInvitationCode && e == 1) {
        this.invitationCode = this.sessInvitationCode;
        this.couponList = [];
      }
      this.setPrice();
    },
    getCouponPrice: function getCouponPrice() {
      var _this3 = this;
      var num = 0;
      this.priceList.forEach(function (item, i) {
        if (_this3.couponList.indexOf(item.id) != -1) {
          if (item.value < 0.01) {
            num = item.value;
          } else {
            num = _this3.calculate(num, Number(item.value), 2, "a");
          }
        }
      });
      return num;
    },
    handleBtn: function handleBtn(e) {
      this.nowActive = e;
      if (e == 1) {
        // this.getInvitationCode();
      } else {
        this.getCoupons();
      }
    },
    handleRegisterBox: function handleRegisterBox() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var activeName, arr, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              activeName = _this4.couponList.length > 0 ? _this4.couponList : "";
              arr = [];
              _this4.shopCartList.forEach(function (item, i) {
                var periodType, num;
                if (item.way_status == 1) {
                  periodType = 1;
                  num = item.num;
                } else {
                  periodType = 5;
                  num = 1;
                }
                if (item.is_free) {
                  periodType = 0;
                  num = 1;
                }
                var json = {
                  name: item.name,
                  periodType: periodType,
                  num: num
                };
                if (!_this4.isUnSupport(item.registerChainIds).status) {
                  if ((item.domainStatus == 0 && !item.protectFlag || item.domainStatus == 0 && item.protectFlag && item.whitelistAddr && item.whitelistAddr.toLowerCase() == _this4.$store.state.account.toLowerCase()) && item.showList) {
                    arr.push(json);
                  }
                }
              });
              if (_this4.inviteStatus != 2) {
                _this4.invitationCode = "";
              }
              if (!(arr.length == 0)) {
                _context.next = 7;
                break;
              }
              _this4.$showTip(_this4.$t("message.err_4100"), "error");
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return _this4.handleRegister({
                arr: arr,
                activeName: activeName,
                is_card: true,
                price: _this4.price
              });
            case 9:
              res = _context.sent;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    currencySelectChange: function currencySelectChange(e, item) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var arrs, arr, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.currencyId = e;
              _this5.currencySelect = item;
              arrs = JSON.parse(JSON.stringify(_this5.shopCartListInit));
              if (_this5.currencyId == _this5.chainid || !_this5.currencyId) {
                arr = _this5.shopCartListInit || [];
                _this5.shopCartList = arr;
                _this5.shopList = arr;
              } else {
                _this5.shopCartList = arrs.filter(function (item) {
                  item.showList = false;
                  for (var i in item.registerPayMethod) {
                    if (_this5.chainid != _this5.currencyId) {
                      if (item.registerPayMethod[i].tokens) {
                        if (item.registerPayMethod[i].tokens.indexOf(_this5.currencyId) != -1) {
                          item.showList = true;
                          break;
                        } else {
                          item.showList = false;
                        }
                      } else {
                        item.showList = false;
                      }
                    } else {
                      item.showList = true;
                    }
                  }
                  return item;
                });
                _this5.shopList = _this5.shopCartList;
              }
              if (_this5.gasTime) {
                clearInterval(_this5.gasTime);
                _this5.gasTime = null;
              }
              _this5.gasPrice = 0;
              _context2.next = 8;
              return _this5.getGasPrice(_this5.registerNumber(_this5.shopCartList, 1), 1);
            case 8:
              res = _context2.sent;
              if (_this5.gasTime) {
                clearInterval(_this5.gasTime);
                _this5.gasTime = null;
              }
              _this5.gasTime = setInterval(function () {
                _this5.getGasPrice(_this5.registerNumber(_this5.shopCartList, 1), 1);
              }, 60000);
              _this5.setPrice();
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getCartList: function getCartList() {},
    init: function init() {
      this.activeNames = ["99"];
      this.couponList = [];
      this.loading = true;
      this.originalPrice = 0;
      this.price = 0;
      this.shopList = [];
      this.nowActive = 1;
      this.invitationCode = "";
      this.copuonCollapse = "99";
      this.getPriceList();
      this.signInviteInfo();
    },
    getPriceList: function getPriceList(e) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var arr, domainArr, arr2, object, domainArray, payStatus, priceArr, format;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              arr = localStorage.getObject("shoppingCartList");
              domainArr = [];
              if (_this6.$store.state.account) {
                _context3.next = 5;
                break;
              }
              _this6.loading = false;
              return _context3.abrupt("return");
            case 5:
              if (arr) {
                _context3.next = 8;
                break;
              }
              _this6.loading = false;
              return _context3.abrupt("return");
            case 8:
              arr2 = [];
              arr.forEach(function (item) {
                domainArr.push(item.name);
                arr2.push(item.way_status ? item.way_status : 1);
              });
              if (!(arr.length > 0)) {
                _context3.next = 32;
                break;
              }
              object = {
                names: domainArr,
                periodTypes: arr2,
                inviteCode: _this6.invitationCode
              };
              domainArray = [];
              _context3.prev = 13;
              payStatus = false;
              _context3.next = 17;
              return Signin.getPriceInfo(object);
            case 17:
              priceArr = _context3.sent;
              format = _this6.$localFormat();
              arr.forEach(function (item) {
                var domainItem = {
                  name: item.name,
                  expired: priceArr.domains[item.name].expiredAt ? moment(priceArr.domains[item.name].expiredAt * 1000).format(format) : 0,
                  checke: false,
                  num: 1,
                  is_free: priceArr.domains[item.name].freeFlag,
                  price: Number(priceArr.domains[item.name].priceYear),
                  buyOut: Number(priceArr.domains[item.name].buyoutPrice),
                  way_status: priceArr.domains[item.name].registerPeriod ? priceArr.domains[item.name].registerPeriod : 1,
                  domainStatus: priceArr.domains[item.name].domainStatus,
                  protectFlag: priceArr.domains[item.name].protectFlag,
                  whitelistAddr: priceArr.domains[item.name].whitelistAddr,
                  firstYearFreeFlag: priceArr.domains[item.name].firstYearFreeFlag,
                  priceDiscount: priceArr.domains[item.name].priceDiscount || 1,
                  registerChainIds: priceArr.domains[item.name].registerChainIds,
                  registerPeriod: priceArr.domains[item.name].registerPeriod,
                  registerPayMethod: priceArr.domains[item.name].payMethod || [],
                  showList: true
                };
                if (priceArr.domains[item.name].payMethod) {
                  payStatus = true;
                }
                domainArray.push(domainItem);
              });
              if (payStatus) {
                _this6.registerPayMethod = [];
                domainArray.forEach(function (item) {
                  if (item.registerPayMethod) {
                    _this6.registerPayMethod.push(item.registerPayMethod);
                  }
                });
                if (payStatus) {
                  _this6.registerPayMethod = _toConsumableArray(new Set(_this6.registerPayMethod));
                }
              }
              _this6.shopCartList = [].concat(domainArray);
              _this6.shopCartListInit = JSON.parse(JSON.stringify(_this6.shopCartList));
              _this6.shopCartList.forEach(function (item, i) {
                if (item.domainStatus == 3) {
                  // this.handRemove(i, item);
                }
              });
              _context3.next = 26;
              return _this6.getGasPrice(_this6.registerNumber(_this6.shopCartList, 1), 1);
            case 26:
              _this6.gasTime = setInterval(function () {
                _this6.getGasPrice(_this6.registerNumber(_this6.shopCartList, 1), 1);
              }, 60000);
              _this6.setPrice();
              _context3.next = 32;
              break;
            case 30:
              _context3.prev = 30;
              _context3.t0 = _context3["catch"](13);
            case 32:
              _this6.loading = false;
              _this6.getCoupons();
              _this6.setPrice();
            case 35:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[13, 30]]);
      }))();
    },
    resetPriceList: function resetPriceList() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var arr, arrList, arr1, i, arr2, object, priceArr, _i;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              arr = [];
              arrList = [];
              arr1 = _this7.shopCartList.filter(function (item, i) {
                return item.way_status === 1;
              });
              for (i in arr1) {
                arr.push(arr1[i].name);
                arrList.push(arr1[i]);
              }
              arr2 = [];
              _this7.shopCartList.forEach(function (item, i) {
                if (arr.indexOf(item.name) == -1) {
                  arr.push(item.name);
                  arrList.push(item);
                }
              });
              arrList.forEach(function (item) {
                var way_status = item.way_status;
                if (way_status != 1) {
                  way_status = 5;
                }
                arr2.push(way_status);
              });
              if (!(arr.length > 0)) {
                _context4.next = 20;
                break;
              }
              object = {
                names: arr,
                periodTypes: arr2,
                inviteCode: _this7.invitationCode
              };
              _context4.prev = 9;
              _context4.next = 12;
              return Signin.getPriceInfo(object);
            case 12:
              priceArr = _context4.sent;
              for (_i in _this7.shopCartList) {
                _this7.shopCartList[_i].whitelistAddr = priceArr.domains[_this7.shopCartList[_i].name].whitelistAddr;
                _this7.shopCartList[_i].firstYearFreeFlag = priceArr.domains[_this7.shopCartList[_i].name].firstYearFreeFlag;
                _this7.shopCartList[_i].protectFlag = priceArr.domains[_this7.shopCartList[_i].name].protectFlag;
              }
              _this7.setPrice();
              _context4.next = 19;
              break;
            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](9);
            case 19:
              _this7.setPrice();
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[9, 17]]);
      }))();
    },
    handleRefresh: function handleRefresh() {
      var arr = [];
      this.shopCartList.forEach(function (item, i) {
        item.num = 1;
        item.way_status = 1;
        arr.push(item);
      });
      this.shopCartList = [].concat(arr);
      this.nowActive = 1;
      this.couponList = [];
      this.setPrice();
    },
    handleClosesBox: function handleClosesBox(e) {
      if (this.gasTime) {
        clearInterval(this.gasTime);
        this.gasTime = null;
      }
      this.$store.commit("setShoppingCartNumber", JSON.stringify(this.shopCartList));
      if (!e) {
        this.$router.push({
          path: "/myName"
        });
      }
      this.$emit("handleClosesBox");
    },
    handleChange: function handleChange(e) {
      var _this8 = this;
      setTimeout(function () {
        var elsment = document.querySelector(".coll-buy-item");
        var ref = document.querySelector(".coll-buy-item");
        //console.log(ref)
        var ref1 = "";
        if (e || e == "0") {
          if (document.querySelector(".coll-collapse".concat(e))) {
            _this8.$nextTick(function () {
              ref1 = document.querySelector(".coll-collapse".concat(e));
              var top = ref1.offsetTop + ref1.offsetHeight - (ref.offsetHeight + ref.offsetTop);
              var top1 = ref1.offsetTop + ref1.offsetHeight - (ref.offsetHeight + ref.scrollTop + ref.offsetTop);
              var top2 = ref1.offsetTop - ref.scrollTop - ref.offsetTop;
              var top3 = ref1.offsetTop - ref.offsetTop;
              if (top2 < 0) {
                elsment.scrollTo({
                  top: top3,
                  behavior: "smooth"
                });
              }
              if (top1 > 0) {
                elsment.scrollTo({
                  top: top,
                  behavior: "smooth"
                });
              }
            });
          }
        }
      }, 400);
    },
    handleChangeYear: function handleChangeYear(value) {
      this.setPrice();
    },
    handRemove: function handRemove(e, list) {
      this.shopCartList = this.shopCartList.filter(function (item, i) {
        return e !== i;
      });
      var json = [];
      this.shopList = this.shopList.filter(function (item, i) {
        return item.name != list.name;
      });
      var shoppingList = JSON.parse(localStorage.getItem("shoppingCartList")) || json;
      if (shoppingList.length > 0) {
        shoppingList = shoppingList.filter(function (col) {
          return col.name != list.name;
        });
      } else {
        shoppingList = [];
      }
      localStorage.setObject("shoppingCartList", shoppingList);
      this.$store.commit("setShoppingCartNumber", JSON.stringify(shoppingList));
      this.resetPriceList();
    },
    handRemoveAll: function handRemoveAll() {
      this.shopCartList = [];
      localStorage.removeItem("shoppingCartList");
      this.$store.commit("setShoppingCartNumber", JSON.stringify(this.shopCartList));
      this.setPrice();
    },
    setPrice: function setPrice() {
      var _this9 = this;
      this.usdPrice = "";
      this.originalPrice = 0;
      this.shopCartList.forEach(function (item, index) {
        if (item.domainStatus == "0" && !item.is_free && !_this9.isUnSupport(item.registerChainIds).status && item.showList) {
          if (item.way_status == 1) {
            _this9.originalPrice = floatOPS.a(_this9.originalPrice, floatOPS.m(item.price, item.num, 2));
            if (Number(item.firstYearFreeFlag) > 0 && item.way_status == 1 && !item.protectFlag || item.protectFlag && item.firstYearFreeFlag == "1" && item.way_status == 1 || item.protectFlag && item.domainStatus == 0 && item.whitelistAddr.toLowerCase() != _this9.$store.state.account.toLowerCase()) {
              _this9.originalPrice = Number(_this9.originalPrice) - Number(item.price);
            }
          } else {
            _this9.originalPrice = floatOPS.a(Number(_this9.originalPrice), Number(item.buyOut), 2);
          }
        }
      });
      this.price = this.originalPrice;
      if (this.nowActive == 1) {
        if (this.inviteStatus == 2) {
          this.price = floatOPS.m(this.originalPrice, this.inviteeDiscount, 2);
        } else {
          this.price = this.originalPrice;
        }
      } else {
        if (this.couponList.length > 0) {
          this.priceList.forEach(function (item, i) {
            var isIcloun = _this9.couponList.filter(function (element) {
              return element === item.id;
            });
            if (isIcloun.length > 0) {
              _this9.price = floatOPS.s(_this9.price, item.value, 2);
            }
          });
        }
      }
      if (this.price < 0) {
        this.price = 0;
      }
      this.usdPriceAdd();
    },
    handChange: function handChange() {
      this.invitationCode = "";
      this.setPrice();
    },
    handSelect: function handSelect(index, e) {
      this.shopCartList[index].way_status = e;
      // this.setPrice();
      this.resetPriceList();
    },
    isUnSupport: function isUnSupport(item) {
      return this.$isUnSupport(item);
    }
  }
};